import { render, staticRenderFns } from "./TopicFeedbackAnalysis.vue?vue&type=template&id=5ad244da&scoped=true&"
import script from "./TopicFeedbackAnalysis.vue?vue&type=script&lang=js&"
export * from "./TopicFeedbackAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TopicFeedbackAnalysis.vue?vue&type=style&index=0&id=5ad244da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad244da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCol,VRow,VSkeletonLoader,VSpacer,VTooltip})
